module.exports = __webpack_public_path__ + "static/media/img04.bdfb6fb6.JPG";